var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('app-bar',{ref:"app-bar",on:{"expand-drawer":_vm.expandDrawer}}),_c('app-drawer',{ref:"app-drawer"}),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }